import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=34512f64&scoped=true&"
import script from "./CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=34512f64&scoped=true&lang=css&"
import style1 from "./CompanyProfile.vue?vue&type=style&index=1&id=34512f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34512f64",
  null
  
)

export default component.exports